// L1–L4 map to the Play Computer's M1–M4 pins, accessible only via Play Shield.
// Show them only when a shield is attached, tracked by the 'shield' session flag.
export const hasPlayShieldPorts = () =>
    sessionStorage.getItem('shield') === 'true'

export default hasPlayShieldPorts
